export default __webpack_public_path__ + "static/media/pricing1.78530ce2.jpg";